import { NavigationBuilderStrategy } from '../types';
import {
	defaultAdminNavigationSchema,
	defaultFooterNavigationSchema,
	defaultSupportNavigationSchema,
	defaultUserNavigationSchema,
} from './schema';
import { defaultNavigationIcons } from './icons';
import { defaultNavigationTitleCodes } from './titles';
import { defaultNavigationUrls } from './urls';
import { defaultTabTitleCodes } from './tabTitleCodes';

export class DefaultNavigationStrategy implements NavigationBuilderStrategy {
	getSchema() {
		return {
			userNavigationItems: defaultUserNavigationSchema,
			adminNavigationItems: defaultAdminNavigationSchema,
			supportNavigationItems: defaultSupportNavigationSchema,
			footerNavigationItems: defaultFooterNavigationSchema,
		};
	}

	getIcons() {
		return defaultNavigationIcons;
	}

	getTitleCodes() {
		return defaultNavigationTitleCodes;
	}

	getUrls() {
		return defaultNavigationUrls;
	}

	getTabTitleCodes() {
		return defaultTabTitleCodes;
	}
}
